import React, { useState, useEffect } from 'react';
import { Checkbox, Link } from 'gatorcomponents';
import * as Styles from './SettingsPopover.styles';
import { localStorageKeys } from '@/enums/storage/storage.enum';
import { MAIA_PRIVACY_POLICY, MAIA_TERMS_OF_USE } from '@/config/urls/supportUrls';

const { showMaiaOnInit } = localStorageKeys;
const SettingsPopover = ({
  label,
  onClose,
  isFullScreen,
  privacyPolicy,
  termsOfUse,
}) => {
  const savedValue = localStorage.getItem(showMaiaOnInit) === 'true' || localStorage.getItem(showMaiaOnInit) === null;

  const [checked, setChecked] = useState(savedValue);
  const handleSetChecked = () => setChecked(!checked);

  useEffect(() => {
    if (checked) {
      localStorage.setItem(showMaiaOnInit, 'true');
    } else {
      localStorage.setItem(showMaiaOnInit, 'false');
    }
  }, [checked]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('#chat-settings-popover')) {
        onClose();
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [onClose]);

  return (
    <Styles.Wrapper $isFullScreen={isFullScreen} data-testid="SettingsPopover" id="chat-settings-popover">
      <Styles.CheckboxWrapper htmlFor="checkDontShowAgain" onClick={handleSetChecked} data-testid="SettingsPopoverCheckbox">
        <Checkbox checked={checked} id="checkDontShowAgain" />
        <Styles.CheckboxDescription onClick={handleSetChecked}>
          {label}
        </Styles.CheckboxDescription>
      </Styles.CheckboxWrapper>

      <Styles.Divider />

      <Styles.LinkWrapper>
        <Link text={privacyPolicy} href={MAIA_PRIVACY_POLICY} />
      </Styles.LinkWrapper>

      <Styles.LinkWrapper>
        <Link text={termsOfUse} href={MAIA_TERMS_OF_USE} />
      </Styles.LinkWrapper>
    </Styles.Wrapper>
  );
};


export default SettingsPopover;
